import { render, staticRenderFns } from "./ProdutosLista.vue?vue&type=template&id=a556030e&scoped=true&"
import script from "./ProdutosLista.vue?vue&type=script&lang=js&"
export * from "./ProdutosLista.vue?vue&type=script&lang=js&"
import style0 from "./ProdutosLista.vue?vue&type=style&index=0&id=a556030e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a556030e",
  null
  
)

export default component.exports